export default __webpack_public_path__ + "static/media/resendMailBred.b2b6cdac.svg";